// This controller serves both regular registration and guest conversion
angular.module('registration')
.controller('RegistrationController', ['$scope', '$q', '$location', '$stateParams', '$uibModal', '$state', 'Notification', 'Auth', 'ModalHandler', 'Practice', 'ProviderInvitation', 'Registration', 'Procedure', 'Referral', 'USER_ROLES',
    function ($scope, $q, $location, $stateParams, $uibModal, $state, Notification, Auth, ModalHandler, Practice, ProviderInvitation, Registration, Procedure, Referral, USER_ROLES) {
        $scope.registrationModes = {
            INVITATION: "INVITATION", // could be registration of either user or practice
            SELF_REGISTRATION: "SELF_REGISTRATION",
            GUEST_CONVERSION: "GUEST_CONVERSION"
        };

        $scope.practiceTypes = Procedure.practiceTypes();

        $scope.roles = [
            USER_ROLES.doctor,
            USER_ROLES.aux
        ];

        $scope.initInvitation = function () {
            $scope.practice = {};

            if ($stateParams.invitation_token) {  // state('registration') in app.js
                $scope.invitation = ProviderInvitation.get(
                    {invitation_token: $stateParams.invitation_token},
                    function (invitationData) {
                        // defaulting to doctor role in case it's not specified in invitation.
                        if (typeof(invitationData.roles_mask) === "undefined" || invitationData.roles_mask === null) {
                            invitationData.roles_mask = USER_ROLES.doctor.mask;
                        }

                        $scope.registrationMode = invitationData.inviter_id ?
                            $scope.registrationModes.INVITATION :
                            $scope.registrationModes.SELF_REGISTRATION;

                        Referral.countByInvited({id: invitationData.id},
                            function(success) {
                                $scope.referrals_count = success.count;
                            }
                        );

                        return invitationData;
                    },
                    function (failure) {
                        $state.go('signIn', {alreadyRegister: true});
                    }
                );

            } else if ($stateParams.conversion_token) {  // state('guest_conversion') in app.js
                $scope.registrationMode = $scope.registrationModes.GUEST_CONVERSION;
                $scope.invitation = Practice.getOwnerParamsByConversionToken(
                    {conversion_token: $stateParams.conversion_token},
                    function(success) {
                        // email, first and last name are now filled
                        $scope.invitation.roles_mask = USER_ROLES.doctor.mask;
                    },
                    function(failure) {
                        Rollbar.error('getOwnerParamsByConversionToken() failed', $stateParams.conversion_token, failure);
                        if (failure.status >= 500) {
                            Notification.error('internal.server.error');
                        } else {
                            Notification.error('conversion.data.not.found');
                        }
                    }
                );

            } else {
                // unknown mode
                Rollbar.error('Unknown registration mode encountered', $stateParams);
                $state.go('signIn');
                return;
            }

        };

        var showResultDialog = function() {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/registration_result.html',
                controller: 'RegistrationResultController'
            });
            ModalHandler.set(modalInstance);
            modalInstance.result.finally(function (res) {
                $state.go('history');
            });
        };

        // this function is used in case of registration through an invitation
        // could be for user or for practice registration
        $scope.register = function (practice, invitation) {
            $scope.submitted = true;
            if(!invitation.practice_id) {
                $scope.setSpecialty(practice, invitation);
            }
            if ($scope.form.$valid) {
                Registration.save({
                        user: invitation,
                        practice: practice, // practice should be empty dict for user registration
                        invitation_token: $stateParams.invitation_token
                    },
                    function (success) {
                        Auth.set({token: success.authentication_token, email: success.email, roles: success.roles, id: success.id, practice_id: success.practice_id});
                        Auth.current_user = success;
                        if (invitation.practice_id) {
                            showResultDialog();
                        } else {
                            $location.url('/');
                        }
                    },
                    function (failure) {
                        if (failure.data.errors) {
                            Notification.error(failure.data.errors.message[0]);
                        } else {
                            console.log("ERROR in response: \n" + JSON.stringify(failure.data));
                            Notification.error('Unexpected server error');
                        }
                    }
                )
            }
        };

        // this function is used instead of register() in case of registering a self-registration invitation
        $scope.createPracticeAndRegister = function (practice, invitation) {
            $scope.submitted = true;
            $scope.setSpecialty(practice, invitation);
            if ($scope.form.$valid) {
                Registration.register_pending_review({
                        user: invitation,
                        practice: practice,
                        invitation_token: $stateParams.invitation_token
                    },
                    function(success) {
                        // object with:
                        // - practice
                        // - user
                        console.log('registered a new account via self-registration invitation: ' + JSON.stringify(success));

                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/pending_review_registration_result.html',
                            controller: 'PendingReviewRegistrationResultController'
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result.finally(function(success) {
                            $state.go('signIn');
                        });
                    },
                    function(fail) {                            
                        if (fail.data.message == 'guest.exists') {
                            $scope.form.email.$setValidity('user', false);
                        }
                        
                        Notification.error(fail.data.message);
                    });
            }

        };

        $scope.convertGuest = function (practice, invitation) {
            $scope.submitted = true;
            $scope.setSpecialty(practice, invitation);
            if ($scope.form.$valid) {
                Registration.convertGuest(
                    {
                        user: invitation,
                        practice: practice,
                        conversion_token: $stateParams.conversion_token
                    },
                    function (success) {
                        var modalInstance = $uibModal.open({
                            templateUrl: 'partials/pending_review_registration_result.html',
                            controller: 'PendingReviewRegistrationResultController'
                        });
                        ModalHandler.set(modalInstance);
                        modalInstance.result.finally(function(success) {
                            $state.go('signIn');
                        });
                    },
                    function (failure) {
                        if(failure.status >= 500) {
                            Notification.error('internal.server.error');
                        } else {
                            Notification.error(failure.data.errors.message[0]);
                        }
                    }
                );
            }
        };

        $scope.checkEmail = function (email) {
            if (!email) {
                return $q.reject();
            }

            var d = $q.defer();
            
            ProviderInvitation.validate({email: email}, function(success) {
                d.resolve();

            }, function(failure){
                if (failure.data.status == 'registered') {
                    Notification.error('invitation.email.register');

                } else if(failure.data.status == 'invited') {
                    if ($scope.registrationMode === $scope.registrationModes.INVITATION) {        
                        d.resolve();
                        return;
                        
                    } else {
                        $scope.resendProvider = failure.data;
                        Notification.error('invitation.email.invited', {resend: function() {
                            ProviderInvitation.resend({id: $scope.resendProvider.id}, function(success) {
                                var modalInstance = $uibModal.open({
                                    templateUrl: 'partials/registration_email_send_message.html',
                                    controller: 'RegistrationEmailResendModalController'
                                });
                                ModalHandler.set(modalInstance);
                            }, function(failure){
                                Notification.error(failure.data.message[0]);
                            });
                        }});
                    }
                }
                
                d.reject();
            });
            
            return d.promise;
        };

        // if invitation has no specialty type, default to general dentistry
        // update practice type to multi_specialty if the practice is multi_specialty, otherwise copy type from invitation
        // if invitation role is auxillary, clear specialty type
        $scope.setSpecialty = function (practice, invitation) {
            if(!invitation.specialty_type_id) {
                $scope.practiceTypes.forEach(function(item) {
                    if(item.code == 'general_dentistry') {
                        invitation.specialty_type_id = item.id;
                    }
                });
            }

            if(practice.multi_specialty) {
                $scope.practiceTypes.forEach(function(item) {
                    if(item.code == 'multi_specialty') {
                        practice.practice_type_id = item.id;
                    }
                });
            } else {
                practice.practice_type_id = invitation.specialty_type_id;
            }

            if(invitation.roles_mask == USER_ROLES.aux.mask) {
                invitation.specialty_type_id = '';
            }
        };

        $scope.resend = function() {
            ProviderInvitation.resend({id: $scope.resendProvider.id}, function(success){
                var modalInstance = $uibModal.open({
                    templateUrl: 'partials/registration_email_send_message.html',
                    controller: 'RegistrationEmailResendModalController'
                });
                ModalHandler.set(modalInstance);
            }, function(failure){
                Notification.error( failure.data.message[0]);
            });
        };

        $scope.discard = function () {
            $scope.initInvitation();
        };

        $scope.initInvitation();
    }]);
